import React, { useCallback } from 'react';
import { ActionsBar, Button, Row, SearchBox } from '@ydistri/ds';
import { addToast } from '@ydistri/utils';
import { useAppDispatch } from '../../../../../store';
import { checkSkuId } from '../../../detailLib';
import { isDigitsOnly } from '@ydistri/generic-utils';

interface SearchPanelProps {
  value?: string;
  onSearch: (query: string) => void;
  onSkuSearch: (skuId: number) => void;
}

const SearchPanel: React.FC<SearchPanelProps> = ({ value, onSearch, onSkuSearch }) => {
  const dispatch = useAppDispatch();

  const skuSearchHandler = useCallback(() => {
    if (!value) {
      return;
    }

    const skuId = parseInt(value, 10);

    try {
      checkSkuId(skuId);
    } catch (e) {
      let message = 'SKU Id is not valid';
      if (e instanceof Error) {
        message = e.message;
      }
      dispatch(addToast({ message, isError: true }));
      return;
    }

    onSkuSearch(skuId);
  }, [dispatch, onSkuSearch, value]);

  return (
    <Row $flexGrow={0} $gap="1rem">
      <SearchBox
        onSearch={onSearch}
        placeholder="Search products"
        value={value}
        flexGrow={1}
        id="product-search-box"
      />
      {value && isDigitsOnly(value) && (
        <ActionsBar>
          <Button onClick={skuSearchHandler} data-testid="SKUSearchButton">
            SKU
          </Button>
        </ActionsBar>
      )}
    </Row>
  );
};

export default SearchPanel;
